import styled from "styled-components";

export const CardContent = styled.div`
  width: 100%;
  height: 100%;
  word-break: break-word;
  border: 1px solid #E5E5E5;
  border-radius: 0 0 5px 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2{
    padding: 10px 0 0 10px !important;
    font-size: 12px !important;
    font-family: 'Roboto', sans-serif  !important;
    font-weight: bold  !important;
    color: #000000  !important;
    margin: 5px 0  !important;
  }
  button{
    width: 100%;
    height: 40px;
    border:  none;
    outline: none;
    border-radius: 0 0 5px 5px !important;
    background-color: transparent;
    font-family: 'Roboto', sans-serif !important;
    color: red;
    font-size: 12px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      background-color: #E6E6E6;
    }
  }
  p{
    padding: 10px 0 0 10px ;
    font-size: 12px;
    font-family: 'Roboto', sans-serif;
    color: #000000;
  }
`;

export const RCSGIFPreview = styled.div`
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: 100%;
  position: relative;

  img {
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    fill: #FFFFFF;
    stroke: #FFFFFF;
    filter: drop-shadow(1px 1px 5px rgba(0, 0, 0, 0.9));
  }
`;

export const ReactVideoPlayer = styled.div`
  width: 100%;
  height: 120px;
  background-color: #E5E5E5;
  border-radius: 10px 10px 0 0;

  .player-wrapper {
    position: relative;
    padding-top: 56.25%;
  }
  .react-player {
    border-radius: 10px 10px 0 0;
    position: relative;
    video {
      border-radius: 10px 10px 0 0;
      object-fit: cover;
    }
  }
`;

